import type * as BABYLON from 'babylonjs';

import type { Color } from './color';
import { toColor3Option } from './color';
import type { Globals } from './globals';
import { compactOptions } from './options';

export interface HemisphericLightOptions {
  direction?: BABYLON.Vector3;
  specular?: Color;
  groundColor?: Color;
  intensity?: number;
}

// cf. https://github.com/BabylonJS/Babylon.js/blob/5.48.1/packages/dev/core/src/Helpers/sceneHelpers.ts#L96-L110
export function createOrUpdateHemisphericLight(
  globals: Globals,
  scene: BABYLON.Scene,
  name: string,
  options: HemisphericLightOptions | null = null
): BABYLON.HemisphericLight | null {
  if (!options) {
    scene.getLightByName(name)?.dispose();
    return null;
  }
  const light =
    (scene.getLightByName(name) as BABYLON.Nullable<BABYLON.HemisphericLight>) ||
    new globals.BABYLON.HemisphericLight(
      name,
      options.direction || globals.BABYLON.Vector3.Up(),
      scene
    );
  Object.assign(
    light,
    compactOptions({
      ...options,
      specular: toColor3Option(globals, options.specular),
      groundColor: toColor3Option(globals, options.groundColor),
    })
  );
  return light;
}

export interface DirectionalLightOptions {
  direction?: BABYLON.Vector3;
  specular?: Color;
  intensity?: number;
}

export function createOrUpdateDirectionalLight(
  globals: Globals,
  scene: BABYLON.Scene,
  name: string,
  options: DirectionalLightOptions | null = null
): BABYLON.DirectionalLight | null {
  if (!options) {
    scene.getLightByName(name)?.dispose();
    return null;
  }
  const light =
    (scene.getLightByName(name) as BABYLON.Nullable<BABYLON.DirectionalLight>) ||
    new globals.BABYLON.DirectionalLight(
      name,
      options.direction || new globals.BABYLON.Vector3(1, -1, 0),
      scene
    );
  Object.assign(
    light,
    compactOptions({
      ...options,
      specular: toColor3Option(globals, options.specular),
    })
  );
  return light;
}
